<p-card styleClass="mb-2" [style]="{width: '100%', position: 'relative', isolation: 'isolate'}">
  <div class="grid grid-nogutter px-1">
    <div class="col-10 flex">
      <app-thumbnail
        size="lg"
        [circle]="true"
        [imgSrc]="resource.thumbnail"
      ></app-thumbnail>
      <div class="col-10 mt-0 pt-0">
        <h4 class="mb-0">
          <a class="search-tile__link" [attr.href]="getTargetUri(resource)" (click)="goToPage(resource, $event)">
            {{resource.alias || resource.name}}
          </a>
        </h4>
        <div *ngIf="resource.alias && resource.type !== 'post'">{{resource.name}}</div>
        <div *ngIf="resource.type === 'post' && getPostAlias(resource)" class="post-search-subtitle">
          <span>{{ getPostAlias(resource) }}</span>
        </div>
        <ng-container *ngIf="resource.type === 'project'">
          <div >{{'shared.top_bar.search_list.from_garage' | translate}} <a>
            <ng-container *ngFor="let user of resource.users || []; let last = last">
              {{user?.username}}<ng-container *ngIf="!last">,</ng-container>
            </ng-container>
          </a>
          </div>
        </ng-container>
        <ng-container *ngIf="resource.type === 'event'">
          <div>
            {{'shared.top_bar.search_list.organized_by' | translate}}
            <ng-container *ngFor="let user of (resource.users || resource.renderData?.organizers || []); let last = last">
              {{user?.username || user?.name || user}}<ng-container *ngIf="!last">,</ng-container>
            </ng-container>
          </div>
          <div>
            {{'shared.top_bar.search_list.organized_on' | translate}}
            <ng-container *ngIf="resource.renderData?.start || resource.subject?.eventDates?.length; else noEventDates">
              <ng-container *ngIf="resource.renderData?.start">{{resource.renderData?.start|date}}</ng-container>
              <ng-container *ngIf="resource.renderData?.end"> - {{resource.renderData?.end|date}}</ng-container>
              <ng-container *ngIf="!resource.renderData?.start">
                <ng-container *ngFor="let user of resource.subject?.eventDates || []; let i = index; let last = last; let first = first">
                  <ng-container *ngIf="first">
                    {{resource.subject?.eventDates?.[i]?.start|date}}
                  </ng-container>
                  <ng-container *ngIf="resource.subject?.eventDates?.length > 1 && last">
                    - {{resource.subject?.eventDates?.[i]?.end|date}}
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
            <ng-template #noEventDates>-</ng-template>
          </div>
        </ng-container>
        <ng-container *ngIf="resource.type === 'post'">
          <div class="post-search-meta" *ngIf="getPostContextLabel(resource) || getPostContextSuffix(resource)">
            <span class="post-search-meta__primary" *ngIf="getPostContextLabel(resource)">
              <i [class]="isCollaborationPost(resource) ? 'pi pi-car' : getPostTypeIcon(resource.renderData?.postType)"></i>
              <span>{{ getPostContextLabel(resource) }}</span>
            </span>
            <span class="post-search-meta__secondary" *ngIf="getPostContextSuffix(resource)">
              | {{ getPostContextSuffix(resource) }}
            </span>
          </div>
          <div class="post-search-subtitle" *ngIf="isCollaborationPost(resource) && getCollaborationUsersLabel(resource)">
            <i class="pi pi-users"></i>
            <span>{{ getCollaborationUsersLabel(resource) }}</span>
          </div>
        </ng-container>
        <ng-container *ngIf="resource.type  === 'marketplace'">
          <h3 class="font-medium text-sm my-1">{{'common.vehicle_offer'|translate}} {{ resource.renderData?.title || resource.subject?.title || resource.name }}</h3>
          <div class="inline-flex flex-nowrap gap-2 text-xs font-light text-overflow-ellipsis">
            <span><i class="icon-engine"></i>{{resource.renderData?.mileage || resource.subject?.project?.attributes?.mileage || '-'}} {{'common.km'|translate}}</span>
            <span>|</span>
            <span><i class="fas fa-gauge-high mr-2"></i>{{resource.renderData?.engineCapacityCm3 || resource.subject?.project?.vehicle?.engine?.capacityCm3 || '-'}} {{'common.cm3' | translate}}</span>
            <span>|</span>
            <span><i class="fas fa-gas-pump fas-ml-1 mr-2"></i>{{(resource.renderData?.fuelType || resource.subject?.project?.vehicle?.engine?.fuelType?.name || resource.subject?.project?.vehicle?.fuelType?.name || resource.renderData?.engineType || resource.subject?.project?.vehicle?.engine?.engineType)|fuelType:false}}</span>
          </div>
          <h2 class="font-medium text-sm mt-2 mb-1">
            <i class="fas fa-wallet mr-2 price"></i><span class="mr-2 price">{{ (resource.renderData?.priceGross || resource.subject?.priceGross)| currency:(resource.renderData?.currency || resource.subject?.currency):'code':'1.0' }}</span>
            <ng-container *ngIf="resource.renderData?.toNegotiation || resource.subject?.toNegotiation"><small class="text-color font-normal">{{'common.to_negotiation'|translate}}</small></ng-container>
          </h2>
        </ng-container>
      </div>
    </div>
    <div class="col-2 flex justify-content-end align-items-start">
      <button *ngIf="hasLastQueriedResources" pButton type="button" icon="pi pi-times"
              class="search-tile__remove p-button-rounded p-button-text p-button-plain p-button-sm"
              [attr.aria-label]="'common.button.remove' | translate"
              (click)="removeSearchLog($event, resource)"></button>
    </div>
  </div>
</p-card>
